// Lib
import React from 'react';

// Components
import Button from '../index';

// Styles
import { useStyles } from './StickyButtonsStyles';

const StickyButtons = ({
  onAccept = () => {},
  onReject = () => {},
  loading,
  submitText = 'Save',
  className,
}) => {
  const { classes, cx } = useStyles();

  return (
    <div className={cx(classes.root, className)}>
      <Button onClick={onReject} id="cancel-button">
        Cancel
      </Button>
      <Button loading={loading} onClick={onAccept} id="save-button">
        {submitText}
      </Button>
    </div>
  );
};

export default StickyButtons;
